import React from 'react';
import { IAvailabilityFeedback } from '../types';

interface IProps {
  availabilityCode: number | null;
  multiplelocations: boolean;
}

export default class AvailabilityFeedback extends React.Component<IProps, {}> {
  available: IAvailabilityFeedback;
  notAvailable: IAvailabilityFeedback;
  constructor(props: IProps) {
    super(props);
    this.available = {
      title: 'Altibox er i nærheten',
      text: 'Norges råeste bredbånd er på plass i nærheten av deg. Hvis du forteller oss hvem bedriften er, kan vi gi deg et tilbud!',
      image: 'https://www.altibox.no/wp-content/uploads/2018/12/thumbs-up-medium-light-skin-tone.png',
    };
    this.notAvailable = {
      title: 'Ikke helt enda',
      text: 'Altibox har ikke bredbånd der din bedrift holder til, men vi bygger kontinuerlig ut bredbåndsnettet for å gi så mange som mulig tilgang til Norges råeste bredbånd. Registrer din interesse, og vi vil kontakte dere når vi vurderer utbygging.',
      image: 'https://www.altibox.no/wp-content/uploads/2018/11/Emoticon_thinking.png',
    };
  }

  render = () => {
    const { availabilityCode, multiplelocations } = this.props;
    const feedback = availabilityCode || multiplelocations ? this.available : this.notAvailable;
    return (
      <div id="availability-feedback">
        <div className="row">
          <div className="col-sm-8">
            <h2 className="title">{feedback.title}</h2>
            <p className="text">{feedback.text}</p>
          </div>
          <div className="col-xs-6 col-xs-offset-3 col-sm-4 col-sm-offset-0">
            <img className="image" src={feedback.image} alt={`Feedback: ${feedback.title}`} />
          </div>
        </div>
      </div>
    );
  };
}
